import semverGte from 'semver/functions/gte';
import semverCoerce from 'semver/functions/coerce';
import { tagCategory, COUNTRY_DISCOUNT_TAGS } from './constants';

export const isVersionGreaterOrEqual = (version, target) => {
  if (!version || typeof version !== 'string') return false;
  try {
    const coercedVersion = semverCoerce(version);
    const coercedTarget = semverCoerce(target);
    return coercedVersion && coercedTarget
      ? semverGte(coercedVersion, coercedTarget)
      : false;
  } catch (e) {
    return false;
  }
};

export const getTagDiscount = (isPlus, label) => ({
  id: '1',
  label,
  category: tagCategory.DEALS_AND_DISCOUNTS,
  hasPlus: isPlus,
});

export const getTagMarkup = (label) => ({
  id: '2',
  label,
  category: tagCategory.POSITIVE,
});

export const getTagPotentialDiscount = (label) => ({
  id: '3',
  label,
  category: tagCategory.DEALS_AND_DISCOUNTS,
  hasPlus: true,
  locked: true,
  doubleStyle: 'default',
});

export const tagDiscount = (countryId) => {
  const tag = COUNTRY_DISCOUNT_TAGS[countryId];
  return tag || 'DTO.';
};

export const getDiscountLabel = (discountArray, countryId) => {
  const item = discountArray?.[0];
  if (item?.amount > 0) {
    return `${`${item.amount}%`} ${tagDiscount(countryId)}`;
  }
  return null;
};

export const getTagExclusive = () => ({
  id: '4',
  label: 'label',
  category: tagCategory.PEDIDOS_YA,
  size: 'medium',
  drop: 'down',
});

export const getBulletDescription = (bullet) => {
  let subValueContent = bullet.sub_value || '';

  if (bullet.type === 'BRAND' && bullet.sub_value) {
    let subValueData;
    try {
      const subValueDataParse = JSON.parse(bullet.sub_value);
      subValueData = subValueDataParse?.map((item) => ({
        brand: item?.brand,
        brand_level: item?.brand_level?.filter((level) => level !== ''),
      }));
    } catch (error) {
      return '';
    }

    if (Array.isArray(subValueData) && subValueData?.length > 0) {
      const brands = subValueData.map((data) => (
        <span key={data?.brand}>
          <strong>{data?.brand}</strong>
          {data.brand_level.length > 0 && ` ${data.brand_level.join(', ')}`}
        </span>
      ));
      subValueContent = brands?.reduce((prev, current, index) => {
        if (index === 0) {
          return [current];
        }
        if (index === brands.length - 1) {
          return [...prev, ' y ', current, '. '];
        }
        return [...prev, '; ', current];
      }, []);
    }
  }
  return subValueContent;
};
